/**
 * Helper de permissões do Operador (Fase 2 — granulares).
 *
 * Lógica:
 * - Login "master" (cliente direto): TODAS as permissões = true (sem operador no sessionStorage).
 * - Login "operador" (/operacao): lê `brave_permissoes` salvo no login.
 * - Operadores antigos (sem flags no banco): default true (compat).
 */

const FLAGS_TRUE_DEFAULT = {
  admin: true,
  controladores: true,
  relatorios: true,
  p_buscar: true,
  p_agendas: true,
  p_lgpd: true,
  p_moradores: true,
  p_funcionarios: true,
  p_visitantes: true,
  p_rel_consolidado: true,
  p_rel_acessos_fixos: true,
  p_rel_acessos_visitantes: true,
  p_rel_empresas: true,
  p_rel_setores: true,
  p_rel_horarios: true,
  p_rel_auditoria: true,
  p_rel_eventos: true,
  p_rel_locais: true,
  p_rel_placas: true,
  p_cad_locais: true,
  p_cad_setores: true,
  p_cad_horarios: true,
  p_cad_operadores: true,
  p_backup: true,
  p_config_sistema: true,
};

export function getPermissoes() {
  try {
    const opRaw = sessionStorage.getItem("brave_operador_data");
    const isMaster = !opRaw || opRaw === "null";
    if (isMaster) {
      return { isMaster: true, ...FLAGS_TRUE_DEFAULT };
    }
    const p = JSON.parse(sessionStorage.getItem("brave_permissoes") || "{}");
    const merged = { ...FLAGS_TRUE_DEFAULT, ...p };
    return { isMaster: false, ...merged };
  } catch {
    return { isMaster: true, ...FLAGS_TRUE_DEFAULT };
  }
}

export function hasPerm(flag) {
  const p = getPermissoes();
  if (p.isMaster) return true;
  return !!p[flag];
}
